/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Success_TitleInputs */

const en_business_form_success_title = /** @type {(inputs: Business_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your interest!`)
};

const es_business_form_success_title = /** @type {(inputs: Business_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por tu interés!`)
};

/**
* | output |
* | --- |
* | "Thank you for your interest!" |
*
* @param {Business_Form_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_success_title = /** @type {((inputs?: Business_Form_Success_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Success_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_success_title(inputs)
	return en_business_form_success_title(inputs)
});